'use client';

import { type FC } from 'react';
import { RushMidTabs } from './RushMidTabs';
import type { RushMidTab } from '../RushMidGame';

export const RushMidTabsBar: FC<{ activeTab: RushMidTab; onChange: (tab: RushMidTab) => void }> = ({ activeTab, onChange }) => (
  <RushMidTabs activeTab={activeTab} onChange={onChange} />
);
